import * as e from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/UserCircle.es.js";
const r = e.forwardRef((o, c) => /* @__PURE__ */ e.createElement(s, { ref: c, ...o, weights: t }));
r.displayName = "UserCircleIcon";
const m = r;
export {
  m as UserCircle,
  r as UserCircleIcon
};
